import { defineQuery } from '@rocicorp/zero';
import { assertIsAuthenticated } from '../utils.js';
import { zql } from '../zero-schema.gen.js';
/**
 * Fetches the single settings row (id = 1) within a Zero transaction.
 * Returns undefined when the row has not been provisioned yet.
 */
export function getSettings(tx) {
    return tx.run(zql.settings.where('id', 1).one());
}
export const settingsQueries = {
    getSettings: defineQuery(({ ctx }) => {
        assertIsAuthenticated(ctx);
        return zql.settings.where('id', 1).one();
    }),
};
//# sourceMappingURL=settings.queries.js.map